var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b2b-data-table__pagination"},[_c('span',{domProps:{"textContent":_vm._s(_vm.$_info)}}),_c('b2b-pagination',_vm._g(_vm._b({},'b2b-pagination',_vm.$props,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }